<template>
    <Container>
        <div class="flex mt-[70px] space-x-[10px] items-center">
            <div class="w-[600px]">
                <h1 class="text-[40px] font-[700] leading-[normal]">{{ heading }}</h1>
                <p class="text-[24px] mt-[14px] leading-[normal]">{{ body }}</p>

                <PrimaryButton :href="buttonLink" class="!inline-block !w-auto mt-[30px]">{{ buttonText }}
                </PrimaryButton>
            </div>
            <div>
                <img alt="" :src="imageSrc" :width="imageWidth" />
            </div>
        </div>
    </Container>
</template>

<script>
import Container from '../../../Layouts/Container'

export default {
    components: {
        Container,
    },

    props: {
        heading: String,
        body: String,
        buttonLink: String,
        buttonText: String,
        imageSrc: String,
        imageWidth: String,
    }
}
</script>
